import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=5bf4f0f3&scoped=true&"
import script from "./PaymentStep.vue?vue&type=script&lang=js&"
export * from "./PaymentStep.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=5bf4f0f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4f0f3",
  null
  
)

export default component.exports